import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=5b49b9b4&"
import script from "./SidePanel.vue?vue&type=script&lang=ts&"
export * from "./SidePanel.vue?vue&type=script&lang=ts&"
import style0 from "./SidePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports